/**
 * useTransactionPalette
 *
 * Theme-aware replacement for the `ADMIN_COLORS.TRANSACTION` hex block. Maps
 * the four canonical transaction states to colors derived from the shared
 * `semantic.status.*` palette so dark/light theme toggles re-tint
 * transaction tables/summaries automatically.
 *
 * Phase 4 feature migrations should replace `ADMIN_COLORS.TRANSACTION.*`
 * lookups with this hook + the matching key.
 */
import { useMemo } from 'react';
import { useThemeColors } from '@/hooks/shared/useThemeColors';

export type TransactionState = 'payment' | 'charge' | 'pending' | 'voided';

export interface TransactionPalette {
  payment: string;
  charge: string;
  pending: string;
  voided: string;
}

export function useTransactionPalette(): TransactionPalette {
  const { semantic } = useThemeColors();
  return useMemo(
    () => ({
      payment: semantic.status.success,
      charge: semantic.status.error,
      pending: semantic.status.warning,
      voided: semantic.text.muted,
    }),
    [semantic.status.success, semantic.status.error, semantic.status.warning, semantic.text.muted],
  );
}
